<template>
<v-app id="app">
    <v-main :style="{'background':dark?'#1e1e1e':'#fff'}">
        <v-container class="pa-0" fluid fill-height>
          <v-flex xs12 fill-height>
                <!-- <vue-page-transition style="height: 100%;" name="zoom" > -->
                  <keep-alive :include="['Nearby','PM']">
                    <router-view></router-view>
                  </keep-alive>
                  
                <!-- </vue-page-transition> -->
            </v-flex>
       </v-container>
    </v-main>
</v-app>
</template>
<script>
export default {
  name: 'App',
  date(){
    return {
      dark:false
    }
  },
  created () {
      this.$store.dispatch('fetchDarkMode');
      this.dark=this.$store.state.dark;
      this.$store.dispatch('fetchUser');
      console.log(this.$store.state.user);
  }
};
</script>
<style lang="sass">

body
  overflow-x: hidden
#app
  +htmlDefault
  +bnbFont
  +text
  +flex
  position: relative
  box-sizing: border-box
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  min-height: 100vh

  -webkit-scrollbar 
    display: none



  -ms-overflow-style: none  
  scrollbar-width: none  

</style>
